module.exports = __webpack_public_path__ + "static/media/montserrat-vietnamese-400-normal.69611381.woff2";